// extracted by mini-css-extract-plugin
export default {"cashback":"Cashback_cashback__VfVOm","details":"Cashback_details__mdCJP","commission":"Cashback_commission__Hgvmu","noCommission":"Cashback_noCommission__tqxEG"};